import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import _ from 'lodash'

import hocConnect from './hocConnect'

import './style.scss'

const pathToImages = require.context('../../../../assets/banner/carousel', false)

@hocConnect
export default class CarouselBanner extends Component {
    static propTypes = {
        configuration: PropTypes.arrayOf(
            PropTypes.shape({
                text: PropTypes.string,
                image: PropTypes.string,
            })
        ),
        id: PropTypes.string.isRequired,
        position: PropTypes.number.isRequired,
        setCarouselPosition: PropTypes.func.isRequired,
        stepTimeMs: PropTypes.number,
    }

    static defaultProps = {
        configuration: [],
        stepTimeMs: 4000,
    }

    constructor(props) {
        super(props)

        this._timer = null
    }

    componentDidMount() {
        const { stepTimeMs } = this.props

        this.setTimer(stepTimeMs)
    }

    // componentWillReceiveProps(nextProps) {
    //     if (this.props.stepTimeMs !== nextProps.stepTimeMs) {
    //         this.setTimer(nextProps.stepTimeMs);
    //     }
    // }

    shouldComponentUpdate(nextProps) {
        if (this.props.position !== nextProps.position) return true
        if (this.props.stepTimeMs !== nextProps.stepTimeMs) return true
        if (this.props.id !== nextProps.id) return true
        if (_.isEqual(this.props.configuration, nextProps.configuration)) return true

        return false
    }

    componentDidUpdate(prevProps) {
        if (this.props.stepTimeMs !== prevProps.stepTimeMs) {
            this.setTimes(this.props.stepTimeMs)
        }
    }

    componentWillUnmount() {
        clearInterval(this._timer)
    }

    onMouseEnterHandler = () => {
        clearInterval(this._timer)
    }

    onMouseLeaveHandler = () => {
        const { stepTimeMs } = this.props

        this.setTimer(stepTimeMs)
    }

    setTimer = (time) => {
        clearInterval(this._timer)
        this._timer = setInterval(() => {
            const { id, position, configuration, setCarouselPosition } = this.props

            const newPosition = position >= configuration.length - 1 ? 0 : position + 1

            setCarouselPosition(id, newPosition)
        }, time)
    }

    render() {
        const { configuration, id, position, setCarouselPosition } = this.props

        const texts = _.map(configuration, (item, index) => (
            <div
                key={`carousel_text_${index}`}
                className={cx('text', position === index && 'active')}
                onClick={() => {
                    setCarouselPosition(id, index)
                }}
            >
                {item.text}
            </div>
        ))
        const images = _.map(configuration, (item, index) => (
            <div
                key={`carousel_image_${index}`}
                className={cx('image', position === index && 'active')}
                style={{ backgroundImage: `url(${pathToImages(`./${item.image}`)?.default})` }}
            />
        ))

        return (
            <div
                className={'carousel-banner'}
                onMouseEnter={this.onMouseEnterHandler}
                onMouseLeave={this.onMouseLeaveHandler}
            >
                <div className={'texts'}>{texts}</div>
                <div className={'images'}>{images}</div>
            </div>
        )
    }
}
